/** Where the candidate studied medicine (Medizinstudium) — Docia only. */
export enum MedicalStudies {
  Germany = 'germany',
  EuEea = 'eu_eea',
  NonEu = 'non_eu',
}

export const MEDICAL_STUDIES_I18N: Record<MedicalStudies, string> = {
  [MedicalStudies.Germany]: 'Deutschland',
  [MedicalStudies.EuEea]: 'EU / EWR',
  [MedicalStudies.NonEu]: 'Nicht-EU',
};
